<template>
    <div v-if="project" class="space-y-4">
        <FlexibleCard headline-id="orgcat" expandable-status="Not-Collapsible">
            <template #header="{ headlineId }">
                <CardHeaderEditable
                    :status="getCardStatus('orgcat')"
                    :edit-button-disabled-explanation="editButtonDisabledMessage('orgcat')"
                    :save-button-disabled-explanation="saveButtonDisabledMessage('orgcat')"
                    @enter-edit-mode="onEnterEditMode('orgcat', $t('organisational-categorization'))"
                    @leave-edit-mode="leaveEditMode('orgcat')"
                    @discard-changes="discardChanges('orgcat')"
                    @save="saveForm('orgcat')"
                >
                    <CardHeadline :headline-id="headlineId">
                        {{ $t('organisational-categorization') }}
                    </CardHeadline>
                </CardHeaderEditable>
            </template>

            <template #body>
                <ContentFormTransition>
                    <ProjectOrgForm
                        v-if="showForm('orgcat')"
                        ref="projectOrgFormRef"
                        :project-id="project.id"
                        class="p-5"
                    />
                    <div v-else>
                        <CardRowText
                            :label="$t('company-group')"
                            :text="valueToString(project.companyGroup)"
                            :has-border-bottom="true"
                        />
                        <CardRowText
                            :label="$t('business-domain')"
                            :text="valueToString(project.businessDomain)"
                            :has-border-bottom="true"
                        />
                        <CardRowText
                            :label="$t('department')"
                            :text="valueToString(project.department)"
                            :has-border-bottom="true"
                        />
                        <CardRowText
                            :label="$t('organisational-changes')"
                            :text="valueToString(project.organisationalChanges)"
                            :has-border-bottom="false"
                        />
                    </div>
                </ContentFormTransition>
            </template>
        </FlexibleCard>
    </div>
</template>

<script setup lang="ts">
import CardHeaderEditable from '@/components/Card/CardHeaderEditable.vue';
import CardHeadline from '@/components/Card/CardHeadline.vue';
import CardRowText from '@/components/Card/CardRowText.vue';
import FlexibleCard from '@/components/Card/FlexibleCard.vue';
import ContentFormTransition from '@/event/components/ContentFormTransition.vue';
import { useFormRegistry } from '@/event/forms/useFormRegistry';
import { useActiveCard } from '@/forms/composables/useActiveCard';
import { valueToString } from '@/forms/forms';
import { $t } from '@/plugins/fluent';
import { useProjectInjection } from '@/project/composables/useProjectInjection';
import ProjectOrgForm from '@/project/forms/project/ProjectOrgForm.vue';
import { useFluent } from 'fluent-vue';
import { useTemplateRef } from 'vue';
import { onBeforeRouteLeave } from 'vue-router';

const fluent = useFluent();

const { project } = useProjectInjection();

const {
    activeCard,
    resetActiveCard,
    onEnterEditMode,
    showForm,
    editButtonDisabledMessage,
    saveButtonDisabledMessage,
    getCardStatus,
} = useActiveCard();

const projectOrgFormRef = useTemplateRef('projectOrgFormRef');
const { register, saveForm, discardChanges, leaveEditMode, resetAll } = useFormRegistry();
register('orgcat', projectOrgFormRef);

onBeforeRouteLeave(() => {
    if (activeCard.value.id && activeCard.value.status === 'Edit-Touched') {
        if (!confirm(fluent.$t('leave-page-warning'))) {
            return false;
        }
        resetAll();
    }
    resetActiveCard();
    return true;
});
</script>
